export default ".gh-email-suppression-faq {\n\n}\n";